import React, { useState, useEffect } from 'react'
import { Formik, Form, useFormikContext } from 'formik';
import FieldsGroup from 'Elements/FieldsGroup'
import { useSelector, useDispatch } from 'react-redux';
import { fieldsToFormik, scrollToTop, fieldsValidation } from '@/Helper'
import { resetStatusContact, updateContact } from 'Reduxes/contact/contactActions'
import Alert from 'Comps/elements/Alert'
import Button from 'Elements/Button';
import { validationSchema } from './validation_edit'
import { serverValue, matchEditValue } from 'Configs/Form'
import { filterMember, loadProvince, loadCity } from 'Reduxes/member/memberActions'
import Select from 'Elements/select/Select'
import Input from 'Elements/Input';
import FieldsContainer from 'Elements/FieldsContainer'
import Textarea from 'Elements/Textarea';

const FormEdit = (props) => {

    const { goToIndex, fieldGroupTop, fieldGroup, fieldGroupExtra } = props;
    const { data, loading, error, idEdit } = useSelector(state => state.contactReducer)
    const dataEdit = data.filter((a, b) => a.id === idEdit)[0]
    const formik = useFormikContext()
    const dispatch = useDispatch();
    dataEdit.password = '';

    const formOpts = {
        initialValues: dataEdit,
        validationSchema,
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            delete values.brand
            delete values.updated_at
            delete values.created_at
            delete values.deleted_at
            delete values.user_category_name
            delete values.user_category_code
            delete values.is_active_label

            // if(values.password === '') {
            //     delete values.password;
            // }
            if (values.is_brand) {
                values.brand_comission = values.brand_comission || 0
                values.brand_comission_type = values.brand_comission_type || 'all_product'
            }
            if (values.is_consignment) {
                values.consignment_comission = values.consignment_comission || 0
                values.consignment_comission_type = values.consignment_comission_type || 'all_product'
            }
            // let cleanVal = serverValue(matchEditValue([...fieldGroupTop, fieldGroup, fieldGroupExtra], values))
            // return;

            let result = await dispatch(updateContact(idEdit, serverValue(values, true)))

            if (result) {
                resetForm();
                goToIndex();
            }

            setSubmitting(false)
            scrollToTop()
        }
    }


    const handleExtraField = values => {
        let extraFieldTmp = [];
        // if (idEdit === 2) {
        //     fieldGroupExtra.map(data => {
        //         data.fields.map(field => {
        //             if (field.name !== 'password') {
        //                 Object.assign(field, { disabled: true, isDisabled: true })
        //             }
        //         })
        //     })
        //     fieldGroup.map(data => {
        //         data.fields.map(field => {
        //             if (field.name === 'name' || field.name === 'is_active') {
        //                 Object.assign(field, { disabled: true })
        //             }
        //         })
        //     })
        //     fieldGroupTop.map(data => {
        //         data.fields.map(field => {
        //             if (field.name === 'is_user' || field.name === 'is_supplier' || field.name === 'is_brand' || field.name === 'is_consignment') {
        //                 Object.assign(field, { disabled: true })
        //             }
        //         })
        //     })
        // }
        if (values.is_user) {
            extraFieldTmp.push(fieldGroupExtra[0])
        }
        if (values.is_brand) {
            extraFieldTmp.push(fieldGroupExtra[1])
            extraFieldTmp.map(data => {
                if (data.name === 'Brand Data') {
                    data.fields.map(field => {
                        if (field.name === 'brand_comission' && values.brand_comission_type === 'by_category') {
                            Object.assign(field, { disabled: true })
                            field.value = '0'
                            values.brand_comission = null
                        } else {
                            Object.assign(field, { disabled: false })
                            field.value = values.brand_comission
                        }
                    })
                }
            })
        }
        if (values.is_consignment) {
            extraFieldTmp.push(fieldGroupExtra[2])
            extraFieldTmp.map(data => {
                if (data.name === 'Partnership Store') {
                    data.fields.map(field => {
                        if (field.name === 'consignment_comission' && values.consignment_comission_type === 'by_category') {
                            Object.assign(field, { disabled: true })
                            field.value = '0'
                            values.consignment_comission = null
                        } else {
                            Object.assign(field, { disabled: false })
                            field.value = values.consignment_comission
                        }
                    })
                }
            })
        }
        return extraFieldTmp;
    }


    // Handle chain address
    const [dataCity, setDataCity] = useState([])

    const handleChangeProvince = async val => {
        setDataCity([])
        const resp = await dispatch(loadCity({ province_name: val.selected.value }))
        setDataCity(resp.data.map(x => ({
            label: x.ibukota, value: x.ibukota
        })))

        if (!val.selected.value) {
            setDataCity([])
        }
    }

    useEffect(() => {

        const loadDataCity = async (province) => {
            const resp = await dispatch(loadCity({ province_name: province }))
            setDataCity(resp.data.map(x => ({
                label: x.ibukota, value: x.ibukota
            })))
        }

        if (dataEdit.province) {
            loadDataCity(dataEdit.province)
        }

    }, [])


    return (
        <>
            {
                error && <Alert hide={() => dispatch(resetStatusContact())} option={{ type: 'error', message: error }} />
            }
            <Formik {...formOpts}>
                {(formik) => {
                    const { values, isSubmitting } = formik;
                    return (
                        <Form className="form-contact">
                            <div className="top">
                                <FieldsGroup fields={fieldGroupTop} />
                            </div>
                            <div className="kiri">
                                <FieldsGroup fields={fieldGroup} />
                                <FieldsContainer title="Address Information">
                                    {/* <Input name="address" col={8} label="Address" disabled={idEdit === 1 ? true : false} /> */}
                                    
                                    {/* Melepaskan form disabled untuk semua contact/user. */}
                                    <Input name="address" col={8} label="Address" />
                                    <div></div>
                                    {/*                                                 
                                    <Input name="province" label="Province" />
                                    <Input name="city" label="City" />
                                    <Input name="postal_code" label="Postal Code" /> 
                                    */}
                                    <Select
                                        col="4"
                                        label="Province"
                                        name="province"
                                        type="province"
                                        portal
                                        options="province"
                                        isClearable
                                        getData={handleChangeProvince}
                                        // isDisabled={idEdit === 1 ? true : false}
                                    />
                                    {
                                        dataCity.length > 0 &&
                                        <Select
                                            col="4"
                                            label="City"
                                            name="city"
                                            type="city"
                                            portal
                                            isClearable
                                            options={dataCity}
                                            // isDisabled={idEdit === 1 ? true : false}
                                        />
                                    }

                                    {/* <Input name="postal_code" label="Postal Code" disabled={idEdit === 1 ? true : false} /> */}
                                    {/* Melepaskan form disabled untuk semua contact/user. */}
                                    <Input name="postal_code" label="Postal Code"/>

                                </FieldsContainer>

                                    {/* Melepaskan form disabled untuk semua contact/user. */}
                                <FieldsContainer title="Other Information">
                                    {/* <Input name="phone" label="Phone" col="4" disabled={idEdit === 1 ? true : false} /> */}
                                    <Input name="phone" label="Phone" col="4"/>
                                    {/* <Input name="email" label="Email" validation='req' col="4" disabled={idEdit === 1 ? true : false} /> */}
                                    <Input name="email" label="Email" validation='req' col="4"/>
                                    {/* <Textarea name="note" label="Notes" col="8" disabled={idEdit === 1 ? true : false} /> */}
                                    <Textarea name="note" label="Notes" col="8"/>
                                </FieldsContainer>
                            </div>
                            {
                                handleExtraField(values).length > 0 && (
                                    <div className="kanan">
                                        <FieldsGroup fields={handleExtraField(values)} />
                                    </div>
                                )
                            }
                            <div className="fields-group-container buttons">
                                <Button
                                    type="submit"
                                    style="OrangeMdWide"
                                    label={isSubmitting ? 'Saving' : 'Save'}
                                    icon={isSubmitting ? 'spinner' : null}
                                    disabled={isSubmitting} />
                                <button disabled={isSubmitting} onClick={goToIndex} type="button" className="btn btn-md btn-wide">Cancel</button>
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </>
    )
}

export default FormEdit